import { render } from "./ClientProjects.vue?vue&type=template&id=2b60c79d&scoped=true"
import script from "./ClientProjects.vue?vue&type=script&lang=js"
export * from "./ClientProjects.vue?vue&type=script&lang=js"

import "./ClientProjects.vue?vue&type=style&index=0&id=2b60c79d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b60c79d"]])

export default __exports__